// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-disabled{cursor:not-allowed;outline:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": "bw-disabled"
};
module.exports = ___CSS_LOADER_EXPORT___;
